import PropTypes from 'prop-types';

const categoryShape = PropTypes.shape({
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  position: PropTypes.number,
  sportId: PropTypes.number.isRequired,
  sportName: PropTypes.string.isRequired,
});

export default categoryShape;
